var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSputnik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 17.002C17 17.6685 17 18.3345 17 19C17 19.6655 16.6687 20.005 16.0062 20.0184H8.01393C7.33798 20.005 7 19.6655 7 19C7 18.3345 7 17.6685 7 17.002V8.02431C7.00051 7.3515 7.33849 7.0151 8.01393 7.0151C8.97526 7.0151 9.82467 7.0151 11.0739 7.0151C12.0801 7.0151 12 6.62251 12 6.02935C12 5.43618 12 4.51615 12 4.00473C12 3.00365 12.6117 3.01734 12.9993 3.01734C13.1138 3.01734 14.7834 3.01734 16.0062 3.01734C16.6687 3.01734 17 3.34647 17 4.00473V17.002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSputnik);
export default __webpack_public_path__ + "static/media/Sputnik.58fac276.svg";
export { ForwardRef as ReactComponent };